/* eslint-disable no-redeclare */

import { dateToAge } from '@hc-frontend/core-utils-date';
import { z } from 'zod';

import { MemberBase } from './member-base';
import { MemberType } from './member-type';

// TODO validate 18 - 99
export const Spouse = MemberBase.extend({
  memberType: z.literal(MemberType.Enum.SPOUSE),
}).superRefine((data, ctx) => {
  if (!data.dateOfBirth) {
    return z.NEVER;
  }

  const age = data.dateOfBirth ? dateToAge(data.dateOfBirth) : 0;

  if (age < 18) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Age must be 18 or more years old.',
    });
  }

  if (age > 99) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Age must be under 99 years old.',
    });
  }

  return z.NEVER;
});

export type Spouse = z.infer<typeof Spouse>;
